export const LEGAL_FORM_TYPE = [
  {
    label: 'REGULAR.LEGAL_FORM_TYPE.PLACEHOLDER',
    value: '',
  },
  {
    label: 'REGULAR.LEGAL_FORM_TYPE.PRIVATE_COMPANY',
    value: 1,
  },
  {
    label: 'REGULAR.LEGAL_FORM_TYPE.PUBLIC_COMPANY',
    value: 2,
  },
  {
    label: 'REGULAR.LEGAL_FORM_TYPE.PUBLIC_PRIVATE_PARTNERSHIP',
    value: 3,
  },
  {
    label: 'REGULAR.LEGAL_FORM_TYPE.INDEPENDENT_FREELANCERS_PROFESSIONALS',
    value: 4,
  },
];
